









































import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
@Component({
  components: {},
})
export default class Tree extends Vue {
  //树形标题
  @Prop() private titleTree: string | undefined;
  //树形内容
  @Prop() private data: Array<any> | undefined;

  //默认选中初始数据
  @Prop({ default: () => [] }) private checkData: any;
  // 树形图的数组
  defaultProps: object = {
    children: 'children',
    label: 'label',
  };
  //是否初始折叠
  isFold: any = true;
  //是否全选
  isAll = false;
  //底层节点idlist
  orlop: any = [];

  //默认选中
  defaultCheckData: any = [];

  /**
   * @desc isAll值监听，当值改变激活方法
   * @param1 暂无
   * @returns 暂无
   */
  @Watch('isAll')
  onValue(value: string, oldValue: string) {
    this.handleCheckAllChange();
  }

  /**
   * @desc isAll值监听，当值改变激活方法
   * @param1 暂无
   * @returns 暂无
   */
  @Watch('checkData')
  async oncheckDataValue(value: any, oldValue: string) {
    const roleTree: any = this.$refs.tree;
    // console.log(this.data);
    roleTree.setCheckedNodes(this.data);
    this.orlop = (this.$refs.tree as any).getCheckedKeys(true);
    // console.log(this.orlop);
    await roleTree.setCheckedKeys([]);
    // console.log(value);
    this.orlop.forEach((item: any) => {
      value.forEach((item2: any) => {
        if (item == item2) {
          this.defaultCheckData.push(item2);
        }
      });
    });
    this.$forceUpdate();
  }

  mounted() {
    // this.isAll = true;
    // const roleTree: any = this.$refs.tree;
    // if (this.isAll) {
    //   roleTree.setCheckedNodes(this.data);
    // } else {
    //   roleTree.setCheckedKeys([]);
    // }
    //
    // const res: any = (this.$refs.tree as any).getCheckedKeys().concat((this.$refs.tree as any).getHalfCheckedKeys());
    // this.$emit('getCheck', { idList: res, objList: this.isAll ? this.data : [] });
    //
    // this.orlop = (this.$refs.tree as any).getCheckedKeys(true);
    // this.isAll = false;
    // this.handleCheckAllChange();
    // this.orlop.forEach((item: any) => {
    //   this.checkData.forEach((item2: any) => {
    //     if (item == item2) {
    //       this.defaultCheckData.push(item2);
    //     }
    //   });
    // });
    // this.$forceUpdate();
  }

  /**
   * @desc 获取选中或半选的节点
   * @param1 data 属性的数组中该节点所对应的对象
   * @param2 checkedObj 树目前的选中状态对象
   * @returns res 传该父级的选择节点
   */
  handleCheckChange(data: any, checkedObj: any) {
    console.log(data);
    console.log(checkedObj);
    const idList: any = [...checkedObj.halfCheckedKeys, ...checkedObj.checkedKeys];
    const objList: any = [...checkedObj.halfCheckedNodes, ...checkedObj.checkedNodes];
    // this.$emit('getCheck');
    // this.creatFunctionList(res)
    this.$emit('getCheck', { idList: idList, objList: objList });
  }

  /**
   * @desc 树形展开操作
   * @param1 暂无
   * @returns 暂无
   */
  canSpread(data: any) {
    data.forEach((el: any) => {
      (this.$refs.tree as any).store.nodesMap[el.id].expanded = true;
      el.children && el.children.length > 0 ? this.canSpread(el.children) : ''; // 子级递归
    });
  }

  /**
   * @desc 树形折叠操作
   * @param1 暂无
   * @returns 暂无
   */
  canFold(data: any) {
    data.forEach((el: any) => {
      (this.$refs.tree as any).store.nodesMap[el.id].expanded = false;
      el.children && el.children.length > 0 ? this.canFold(el.children) : ''; // 子级递归
    });
  }

  /**
   * @desc 树形全选操作
   * @param1 暂无
   * @returns res 传该父级的选择节点
   */
  handleCheckAllChange() {
    const roleTree: any = this.$refs.tree;
    if (this.isAll) {
      roleTree.setCheckedNodes(this.data);
    } else {
      roleTree.setCheckedKeys([]);
    }

    const res: any = (this.$refs.tree as any).getCheckedKeys().concat((this.$refs.tree as any).getHalfCheckedKeys());
    this.$emit('getCheck', { idList: res, objList: this.isAll ? this.data : [] });
  }
}
